export default "__VITE_ASSET__c5b8c3c4__"